import { IconMainMenuSettings } from "@suse-o11y/icons";
import React, { type FC } from "react";

import { Permission } from "~/models/dto";

import { usePermissions } from "../../common/use-permissions";
import { useNavigateToLink } from "../../components/react/link";
import { SETTINGS_PATH } from "../../routes/Routes";

import { MainMenuItemLayout } from "./MainMenuItemLayout";

export const MainMenuItemSettings: FC = () => {
	const hasEditSettingsPermission = usePermissions(
		(permissions) =>
			permissions.hasSystemPermission(Permission.GetSettings) &&
			permissions.hasSystemPermission(Permission.UpdateSettings),
	);

	const link = useNavigateToLink(SETTINGS_PATH, {
		params: {
			name: undefined,
		},
		search: ["timeRange", "timestamp", "detachedFilters"],
	});

	if (!hasEditSettingsPermission) {
		return null;
	}

	return (
		<MainMenuItemLayout
			className="settingsMenu"
			icon={<IconMainMenuSettings height={18} width={18} />}
			label="Settings"
			to={link}
		/>
	);
};
